import {
  Dialog as DialogRoot,
  DialogContent,
  DialogPortal,
  cn,
} from "@mozioinc/ui";
import type { ReactNode } from "react";

type DialogProps = {
  children: ReactNode;
  error?: boolean;
  icon?: ReactNode;
  open?: boolean;
};

export const Dialog = ({ icon, children, error, ...props }: DialogProps) => (
  <DialogRoot {...props}>
    <DialogPortal>
      <DialogContent className="flex max-w-md flex-col items-center justify-center bg-neutral-100 p-5 outline-none">
        {icon && (
          <div
            className={cn(
              "-mt-24 flex h-32 w-32 items-center justify-center rounded-full border",
              {
                "bg-error-400 border-error-400": error,
                "border-neutral-200 bg-white": !error,
              },
            )}
          >
            {icon}
          </div>
        )}
        {children}
      </DialogContent>
    </DialogPortal>
  </DialogRoot>
);
